<template>
  <b-container v-if="createAny('users')" fluid>
    <div class="title-bar">
      <h1>{{ $t("titles.planningrules") }}</h1>
      <div @click="edit_ruleset({ id: 0 })" class="btn btn-primary">
        <font-awesome-icon icon="plus" /> {{ $t("buttons.addruleset") }}
      </div>
    </div>
    <b-table :items=planningrules :fields=rulefields >
      <template #cell(actions)="row">
        <div class="action-items">
          <a href="javascript:;" class="btn" @click="delete_a_code(row.item.id)" :title="$t('labels.deletebiccode')">
            <font-awesome-icon icon="trash" /> {{$t('labels.delete')}}
          </a>
        </div>
      </template>
      <template #cell(rules)="row">
        <div @click="edit_rule({ id: 0 ,rule_id:row.item.id})" class="btn btn-primary">
        <font-awesome-icon icon="plus" /> {{ $t("buttons.addrule") }}
      </div>
      
      <b-table :items=row.item.rules :fields="ruletypefields">
        <template #cell(type_id)="row">
          {{ planningruletype_by_id(row.item.type_id).title }}
        </template>

      </b-table>
      </template>
      </b-table>
    <!-- Table -->
    <h1>Planning types</h1>

    <b-table :items=planningruletypes :fields=fields>

      <template #cell(EU)="row">
        <font-awesome-icon v-if="row.item.EU==1" icon="check"  style="color: green;" />
        <font-awesome-icon v-else icon="times" style="color: red;" />
      </template>
    </b-table>

  </b-container>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ruleset_detail_modal from './modals/PlanningRulesetModal.vue'
import rule_detail_modal from './modals/PlanningRuleModal.vue'
import popup_modal from './modals/PopupModal.vue'

export default {
  name: 'codesscreen',
  data() {
    return {
      selectedID: null,
    }
  },
  computed: {
    fields() {
      return [
      { key: 'title', label: this.$i18n.t('labels.title'), sortable: true, sortDirection: 'desc' },
      { key: 'description', label: this.$i18n.t('labels.invoice_extra_description'), sortable: true, sortDirection: 'desc' },
      ]
    },
    rulefields() {
      return [
      { key: 'rulename', label: this.$i18n.t('labels.title'), sortable: true, sortDirection: 'desc' },
      { key: 'rules', label: this.$i18n.t('labels.invoice_extra_description'), sortable: true, sortDirection: 'desc' },
      { key: 'actions', label: this.$i18n.t('labels.actions') },

      ]
    },
    ruletypefields(){
      return [
      { key: 'type_id', label: this.$i18n.t('labels.title'), sortable: true, sortDirection: 'desc' },
      { key: 'actions', label: this.$i18n.t('labels.actions') },
      ]
    },

    ...mapState([
      'planningruletypes',
      'planningrules'
    ]),
    ...mapGetters([
    'planningruletype_by_id',
      'confirm_modal',
      'createAny'

    ]),
  },
  async mounted(){
  },

  methods: {
    ...mapActions([
      'delete_biccode',
      'save_biccode'
    ]),
    delete_a_code(id) {
      this.selectedID = id
      let message = this.$i18n.t('labels.confirmdeletehead') + this.biccode_by_id(id).code + this.$i18n.t('labels.confirmdeletetail')
      this.$modal.hide('popup_modal')
      this.$modal.show(popup_modal, {
        message: message,
      }, {
        name: 'popup_modal',
        draggable: false,
        height: 'auto',
        width: '500px'
      }, {
        'before-close': this.modalClose
      })

      this.$emit('close')

    },
    modalClose() {
      if (this.confirm_modal.id == 1) {
        this.delete_biccode(this.selectedID);
        for (let i = 0; i < this.biccodes.length; i++) {
          if (this.biccodes[i].id == this.selectedID) {
            this.biccodes.splice(i, 1);
          }
        }
      }
    },
    oncodeClicked(row) {
      this.$modal.hide('ruleset_detail_modal')
      this.$modal.show(ruleset_detail_modal, {
        id: row.id
      }, {
        name: 'ruleset_detail_modal',
        draggable: '.popup-header',
        height: 'auto',
        width: '800px'
      })

      this.$emit('close')
    },
    edit_ruleset(code) {
      this.$modal.hide('ruleset_detail_modal')
      this.$modal.show(ruleset_detail_modal, {
        code_id: code.id,
      }, {
        name: 'ruleset_detail_modal',
        draggable: '.popup-header',
        height: 'auto',
        width: '800px'
      })

      this.$emit('close')
    },
    edit_rule(code ) {
      console.log("ëdit_rule",code)
      this.$modal.hide('rule_detail_modal')
      this.$modal.show(rule_detail_modal, {
        code_id: code.id,
        rule_id:code.rule_id

      }, {
        name: 'rule_detail_modal',
        draggable: '.popup-header',
        height: 'auto',
        width: '800px'
      })

      this.$emit('close')
    },
    
  },
}
</script>